<template>
  <svg
    aria-hidden="true"
    preserveAspectRatio="none"
    viewBox="0 0 440 500"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon points="440 250 0 0 0 500 440 250" vector-effect="non-scaling-stroke"></polygon>
  </svg>
</template>
